import {computed, Directive, inject} from "@angular/core";
import {FormField} from "@angular/forms/signals";

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: "[formField]:not([appNoValidationClasses])",
  host: {
    "[class.is-valid]": "isTouched() && isDirty() && isValid()",
    "[class.is-invalid]": "isTouched() && isDirty() && isInvalid()",
  },
})
export class BootstrapFormFieldValidationClasses<TValue> {
  // public readonly formField = input.required<Field<TValue, TKey>>();
  private readonly formField = inject(FormField<TValue>);

  protected readonly isTouched = computed(() => this.formField.state().touched());
  protected readonly isDirty = computed(() => this.formField.state().dirty());
  protected readonly isValid = computed(() => this.formField.state().valid());
  protected readonly isInvalid = computed(() => this.formField.state().invalid());
}
